import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentCwvConfig } from '../../../../catalog/config/component.config';

export namespace NCmsBlogComponentImageWithOverlappingCopy {
    export const ID = 'image-with-overlapping-copy';

    export interface IData extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
        component_width?: 'full' | 'fixed';
        copy?: string;
        image?: string;
        url?: string;
    }
}
